@if (isSchoolSiteRoute()) {
    <router-outlet></router-outlet>
} @else {
    <div class="dashboard" [class.dashboard--sidebar-expanded]="isSidebarExpanded()">
        <app-header (toggleSidebar)="toggleSidebar()"></app-header>
        <app-sidebar
            [isExpanded]="isSidebarExpanded()"
            (isExpandedChange)="isSidebarExpanded.set($event)"
        ></app-sidebar>
        <div class="app__contentarea" cdkScrollable>
            <router-outlet></router-outlet>
        </div>
    </div>
}

<z-toaster
    position="top-right"
    theme="light"
    [richColors]="true"
    [closeButton]="true"
    [duration]="4000"
    [expand]="true"
    [visibleToasts]="8"
    [toastOptions]="toastOptions"
/>
<!-- DISABLED <app-freeze></app-freeze> -->
